import React, { Component, PropTypes } from 'react';
import Controls from '../../util/controls';
import BookingWizardConfirmDetails from './bookingWizardConfirmDetails';
import BookingWizardConfirmIntegratedDetails from './bookingWizardConfirmIntegratedDetails';
import BookingWizardVerification from './bookingWizardVerification';
import BookingWizardPickDateQuick from './bookingWizardPickDateQuick';

class BookingWizard extends Component {
    constructor(props) {
        super(props);
        this.pages = 4;
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.onConfirmDetails = this.onConfirmDetails.bind(this);
        this.state = {
            page: 1
        };
    }

    nextPage(event, page) {
        event && event.preventDefault();
        this.setState({ page: page || this.state.page + 1 });
        window.scrollTo(0, 0);
    }

    previousPage() {
        event.preventDefault();

        const { isIntegrated, isProjectUpgrade } = this.props.booking.details;
        
        let pageAdjust = (!isIntegrated || isProjectUpgrade) && this.state.page == 3 ? 2 : 1;

        this.setState({ page: this.state.page - pageAdjust });

        window.scrollTo(0, 0);
    }

    onConfirmDetails(event) {
        const { isrefpfsDepot, isIntegrated, isProjectUpgrade } = this.props.booking.details;

        if (isrefpfsDepot)
            this.props.onConfirmBooking();
        else if (!isIntegrated || isProjectUpgrade)
            this.nextPage(event, 3);
        else
            this.nextPage(event);
    }

    render() {
        const { onConfirmBooking, onBookingDataSelection, booking: { bookingAvailability, details } } = this.props;
        const { page } = this.state;

        if (page === 2 && !bookingAvailability) {
            return (
                <Controls.LoadingPanel />
            );
        }

        return (
            <div>
                <div className="screen-header">
                    <div className="row">
                        {page > 1 ? (
                            <div className="col-xs-4" onClick={this.previousPage}>
                                <span className="back-button"><i className="fa fa-caret-left" /> Back</span>
                            </div>
                        ) : (
                            <div className="col-xs-4" />
                        )}
                        <div className="col-xs-4 text-center">
                            {details.isProjectUpgrade ? "Book Upgrade" : "Book Install" }
                        </div>
                    </div>
                    <div className="wizard-progress">
                        <div className="wizard-progress-fill" style={{width: (page / this.pages) * 100 + "%"}} />
                    </div>
                </div>
                {page === 1 && <BookingWizardConfirmDetails previousPage={this.previousPage} onSubmit={this.onConfirmDetails} {...this.props} />}
                {page === 2 && <BookingWizardConfirmIntegratedDetails onBookingDataSelection={onBookingDataSelection} previousPage={this.previousPage} onSubmit={this.nextPage} {...this.props} />}
                {page === 3 && <BookingWizardPickDateQuick onBookingDataSelection={onBookingDataSelection} onSubmit={this.nextPage} {...this.props} />}
                {page === 4 && <BookingWizardVerification previousPage={this.previousPage} onConfirmBooking={onConfirmBooking} {...this.props} />}
            </div>
        );
    }
}

BookingWizard.propTypes = {
    onBookingDataSelection: PropTypes.func.isRequired,
};

export default BookingWizard;


// WEBPACK FOOTER //
// ./app/booking/components/bookingWizard.js